import { DatePicker } from 'antd';
import dayjs, { ConfigType, Dayjs } from 'dayjs';
import { formatDate } from './constants';

interface DatePickerProps {
  placeholder: string;
  style?: React.CSSProperties;
  disabled?: boolean;
  onChange?: () => void;
}

export const getDateValueProps = (value: ConfigType): Record<string, Dayjs | undefined> => ({
  value: value ? dayjs(value) : undefined,
});

export const DefaultDatePicker = (props: DatePickerProps) => {
  const disabledDate = (current: Dayjs) => current < dayjs().startOf('day');
  return <DatePicker format={formatDate} disabledDate={disabledDate} {...props} />;
};
